<template>
<div class="container">

        <div class="row">
            <app-carrousel />

        </div>
        
        <br/>
        <div class="row">
            <div class="" style="text-align: left;">
                <p>
                    Bienvenidos a nuestra plataforma interactiva, donde con solo tres pasos podrás generar tu Contrato, Derecho de Petición o
                    Tutela y contar con la asesoría legal que necesitas a solo un click de distancia. También tendrás acceso
                    a temas de interés y actualidad jurídica.
                </p>
                <p>
                    Escríbenos, sin ningún costo, a través de nuestra plataforma y recibe asesoría eficiente y con prontitud en cualquiera de
                    las áreas del derecho que demande tu necesidad.
                </p>
                <p>
                    El particular ejercicio de aplicar el método científico (investigación) a cada una de las asesorías y consultorías legales,
                    nos define como el único equipo de abogados completo e integral en la prestación de servicios jurídicos.
                </p>
                <p>
                    Nuestros servicios son prestados con un trato humano y personalizado, de cara a su necesidad.
                </p>
            </div>


        </div>
    </div>
</template>

<script>
import Carrousel from './carrousel.vue'
export default {
    components:{
        'app-carrousel': Carrousel
    }
}
</script>


<style scoped>
.container {
    width: 80%;
    margin-left: 10%;
    margin-top: 5%;
  }

h1 {
  text-align: center;
}

p {
  text-align: justify;
}

.cta {
  width: 300px;
  margin: auto;
  /* text-align: center; */
}

.cta a {
  margin: 10px;
  text-decoration: none;
  display: inline-block;
  border: 1px solid #521751;
  border-radius: 3px;
  width: 100px;
  padding: 10px;
  box-sizing: border-box;
  color: #521751;
}

.cta a:hover,
.cta a:active {
  background-color: #521751;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/navigate/inicio.vue